import React, { FC, useEffect } from 'react'
import LoginFormBody from '../common/LoginFormBody/LoginFormBody'
import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'
import {
	CircularProgress,
	FormControlLabel,
	FormLabel,
	Radio,
} from '@mui/material'
import Button from '@mui/material/Button'
import {
	mfaChallenge,
	setMfaOOBChannel,
} from '../../../store/reducers/auth/actions'
import {
	selectAuthenticatorId,
	selectMfaRequiredError,
	selectMfaToken,
	selectOobChannel,
} from '../../../store/reducers/auth/selectors'
import { history } from '../../../store'
import {
	PAGE_LOGIN,
	PAGE_LOGIN_2FA_CODE,
	PAGE_LOGIN_2FA_PHONE,
} from '../../../constants/navigation'
import { useTypedSelector } from '../../../hooks/useTypedSelector'
import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'

const LOGIN_METHOD_EMAIL = 'email'
const LOGIN_METHOD_SMS = 'sms'

const Login2FAMethodForm: FC = () => {
	const oobChannel = useTypedSelector(selectOobChannel)
	const mfaToken = useTypedSelector(selectMfaToken)
	const mfaRequiredError = useTypedSelector(selectMfaRequiredError)
	const authenticatorId = useTypedSelector(selectAuthenticatorId)
	const { loading, setLoading, isMounted, alert, dispatch } =
		useDefaultComponentTools()

	useEffect(() => {
		if (!mfaRequiredError) {
			history.replace(PAGE_LOGIN)
		}
	}, [mfaRequiredError])

	const handleOnChange = (
		event: React.ChangeEvent<HTMLInputElement>
	): void => {
		dispatch(setMfaOOBChannel(event.target.value))
	}

	const handleClickLogin = async (): Promise<void> => {
		try {
			if (!mfaToken) {
				alert.error('Invalid mfa token.')

				return
			}

			setLoading(true)

			if (oobChannel === 'sms' && !authenticatorId) {
				history.replace(PAGE_LOGIN_2FA_PHONE)
				return
			}

			await dispatch(mfaChallenge(authenticatorId, mfaToken))

			history.replace(PAGE_LOGIN_2FA_CODE)
		} catch (e: any) {
			'message' in e && alert.error(e.message)
		} finally {
			isMounted() && setLoading(false)
		}
	}

	const isLoginDisabled = !oobChannel || loading

	return (
		<LoginFormBody
			title={'Login'}
			subTitle={'Multifactor authentication required'}
		>
			<FormControl component={'fieldset'} sx={{ mt: 5.1, mb: 12.4 }}>
				<FormLabel
					component={'legend'}
					sx={{ fontFamily: 'Gilroy-Medium, sans-serif', mb: 1 }}
				>
					Choose your login method
				</FormLabel>

				<RadioGroup
					row
					value={oobChannel}
					name='radio-buttons-group'
					onChange={handleOnChange}
				>
					<FormControlLabel
						value={LOGIN_METHOD_EMAIL}
						control={<Radio />}
						label='Email'
						sx={{ mr: 6.2 }}
					/>

					<FormControlLabel
						value={LOGIN_METHOD_SMS}
						control={<Radio />}
						label='SMS'
					/>
				</RadioGroup>
			</FormControl>

			<Button
				color={'primary'}
				variant={'contained'}
				size={'large'}
				disabled={isLoginDisabled}
				onClick={handleClickLogin}
				sx={{ width: '8.75rem' }}
			>
				{loading ? <CircularProgress size={28} /> : 'Login'}
			</Button>
		</LoginFormBody>
	)
}

export default Login2FAMethodForm
